import Box from "@material-ui/core/Box";
import React from "react";
import { TextField, Typography } from "@material-ui/core";
import gameSetStyles from "../styles/GameSet.style";
import matchSettingsStyles from "../styles/MatchSettings.styles";

const MatchTiebreakPoints = ({
	points = 20,
	match,
	onAwayPointsChange,
	onHomePointsChange
}) => {
	const classes = gameSetStyles();
	const settingsClasses = matchSettingsStyles();

	const { tiebreakPoints } = match;
	const { away, home } = tiebreakPoints || {};

	return (
		<Box display="flex" flexDirection="column" alignItems="center">
			<Typography className={settingsClasses.settings} variant="subtitle1">
				Up to <span className={settingsClasses.settingValue}>{points}</span> points
			</Typography>
			<Box display="flex" justifyContent="center">
				<TextField
					id="awayMatchTiebreakPoints"
					variant="outlined"
					name="awayMatchTiebreakPoints"
					className={classes.score}
					InputLabelProps={{
						shrink: true
					}}
					type="number"
					value={away}
					step="1"
					onChange={(e) => onAwayPointsChange(e.target.value)}
					placeholder="-"
					style={{ width: 48 }}
				/>
				<div className={classes.spacing} />
				<TextField
					id="homeMatchTiebreakPoints"
					variant="outlined"
					name="homeMatchTiebreakPoints"
					className={classes.score}
					InputLabelProps={{
						shrink: true
					}}
					type="number"
					value={home}
					step="1"
					onChange={(e) => onHomePointsChange(e.target.value)}
					placeholder="-"
					style={{ width: 48 }}
				/>
			</Box>
		</Box>
	);
};

export default MatchTiebreakPoints;
